import { gql } from '@apollo/client';

/**
 * GraphQL mutation to update strike workflow configuration
 */
export const UPDATE_STRIKE_CONFIGURATION = gql`
  mutation UpdateStrikeWorkflowConfiguration($communityId: ID!, $type: String!, $input: UpsertCommunityWorkflowConfigurationInput!) {
    upsertCommunityWorkflowConfiguration(communityId: $communityId, type: $type, input: $input) {
      type
      rollingWindowDays
      labelStrikeMappings {
        labelId
        severity
        points
      }
    }
  }
`;
